import React from "react";
import { PropTypes } from 'prop-types'
import styles from './data-container.module.scss'
import { useNavigate, generatePath } from 'react-router-dom'
import { Table } from "antd";
import { EnquiryColumns } from "../../library/constants";


const OpenEnquiries = ({ enquiries }) => {
    const navigate = useNavigate()
    const handleRowClick = (record) => {
        navigate(generatePath('/quotation/:id', {
            id: record.id
        }))
    }
    return (
        <div>
            <div className={styles.enquiryHeader}>
                <h3>Quotation</h3>
            </div>
            <Table onRow={(record) => ({
            onClick: event => {
                if (event.target.closest('input[type="checkbox"], .ant-checkbox, .ant-checkbox-wrapper')) {
                    return
                }
                event.preventDefault()
                handleRowClick(record)
            }
        })} className={styles.enquiryBox} dataSource={enquiries} columns={EnquiryColumns} pagination={false} footer={() => <a onClick={() => { navigate('/quotation') }} >See More</a>} />
        </div>
    )
}

OpenEnquiries.propTypes = {
    enquiries: PropTypes.array
}

export default OpenEnquiries
